import React from 'react';

interface SelectionCheckboxProps {
    isSelected: boolean;
    onChange: (e: React.MouseEvent) => void;
    isFocused?: boolean;
    focusedTooltip?: string;
}

const SelectionCheckbox: React.FC<SelectionCheckboxProps> = ({
    isSelected,
    onChange,
    isFocused,
    focusedTooltip
}) => {
    return (
        <div className="relative flex items-center">
            <input
                type="checkbox"
                checked={isSelected}
                onClick={onChange}
                readOnly
                className="h-4 w-4 accent-cyan-600 cursor-pointer"
            />
            {isFocused && (
                <div className="absolute inset-0 flex items-center justify-center">
                    <input
                        type="checkbox"
                        checked
                        readOnly
                        className="h-4 w-4 accent-neutral-500 opacity-50 cursor-pointer"
                        data-tooltip-id="main-tooltip"
                        data-tooltip-content={focusedTooltip || "Focused item"}
                        data-tooltip-place="right-start"
                    />
                </div>
            )}
        </div>
    );
};

export default SelectionCheckbox;